// import utils
import { badgeClasses } from "@mui/material/Badge";
export default {
    styleOverrides: {
        root: {
            variants: [
                {
                    props: { variant: "standard" },
                    style: {
                        [`& .${badgeClasses.standard}`]: {
                            width: 16,
                            height: 16,
                            fontSize: 11,
                            fontWeight: 400,
                        },
                    },
                },
            ],
        },
    },
};
